// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".botton-actions[data-v-364aad94] {\n  position: absolute;\n  top: 0;\n  /* width: 100%; */\n  margin-top: 10px;\n  left: 0;\n}\n.Link[data-v-364aad94] {\n  color: var(--color-secondary);\n}", ""]);
// Exports
module.exports = exports;
